const categories = [
    { id: 1, name: 'Trauer feiern Abschiede gestalten' },
    { id: 2, name: 'Zeit und Muße' },
    { id: 3, name: 'Bestattungsarten / Grabarten' },
    { id: 4, name: 'Särge' },
    { id: 5, name: 'Decken' },
    { id: 6, name: 'Urnen' },
    { id: 7, name: 'Begleitendes' },
    { id: 8, name: 'Floristik' },
    { id: 9, name: 'Trauerdruck' },
    { id: 10, name: 'Bestattungsvorsorge' },

];
export default categories